import pt from "prop-types";
/**
 * @todo: Migrate this to typescript type
 */
export default {
  error: pt.oneOfType([pt.shape({}), pt.bool]),
  isErrorVisible: pt.bool,
  data: pt.shape({
    productSummary: pt.shape({
      title: pt.string,
      pdpUrl: pt.string,
      isFinalSale: pt.bool,
    }),
    allSize: pt.arrayOf(
      pt.shape({
        available: pt.bool,
        size: pt.string,
      })
    ),
    productCarousel: pt.arrayOf(
      pt.shape({
        color: pt.shape({
          code: pt.string,
          name: pt.string,
        }),
        imageInfo: pt.arrayOf(pt.string),
      })
    ),
    colorDriver: pt.arrayOf(
      pt.shape({
        color: pt.string,
        sizes: pt.arrayOf(pt.string),
      })
    ),
    onError: pt.func,
    onLoad: pt.func,
    variants: pt.arrayOf(
      pt.shape({
        price: pt.shape({
          listPrice: pt.string,
          currency: pt.shape({
            code: pt.string,
            symbol: pt.string,
          }),
          onSale: pt.bool,
          salePrice: pt.string,
        }),
        color: pt.shape({
          code: pt.string,
          name: pt.string,
          swatchUrl: pt.string,
          slug: pt.string,
        }),
        imageSet: pt.shape({
          images: pt.arrayOf(
            pt.shape({
              url: pt.string,
              alt: pt.string,
            })
          ),
          modelDescription: pt.string,
        }),
      })
    ),
    skus: pt.arrayOf(
      pt.shape({
        id: pt.string,
        styleId: pt.string,
        color: pt.shape({
          code: pt.string,
          name: pt.string,
          swatchUrl: pt.string,
          slug: pt.string,
        }),
        size: pt.string,
        available: pt.bool,
        inseam: pt.string,
        price: pt.shape({
          listPrice: pt.string,
          currency: pt.shape({
            code: pt.string,
            symbol: pt.string,
          }),
          onSale: pt.bool,
          salePrice: pt.string,
        }),
      })
    ),
  }),
};
